import { Page } from "@/components/page";
import { Text, Stack, Box, Title } from "@mantine/core";

import { createFileRoute } from "@tanstack/react-router";
import { DisconnectPatreonCard } from "./-components/disconnect-patreon-card";
import { CancelScrolllerSubscriptionCard } from "./-components/cancel-scrolller-subscription-card";

export const Route = createFileRoute(
  "/_authenticated/_subscribed/_main/subscription/",
)({
  component: SubscriptionRouteComponent,
});

function SubscriptionRouteComponent() {
  return (
    <Page title="Settings">
      <Title>Subscription</Title>
      <Text>Your subscription settings.</Text>
      <Box maw="700px" mt="xl">
        <Stack>
          <DisconnectPatreonCard />
          <CancelScrolllerSubscriptionCard />
        </Stack>
      </Box>
    </Page>
  );
}
